import React, { ReactElement } from 'react';
import InvoicePaymentForm from '../../../views/invoices/InvoicePaymentForm';
import { ModalProps } from '../ModalContext';

export const handleRegisterPayment = ({ invoiceId, userHash, t, initializeModal, fetchData }: {
    invoiceId: number,
    userHash?: string,
    t: (key: string, options?: any) => string,
    initializeModal: (content: ReactElement<any>, props?: ModalProps) => void,
    fetchData?: () => void,
}) => {

    // Initialize the register payment modal
    initializeModal(
        <InvoicePaymentForm linkedItem={{ 
            invoice: invoiceId,
            ...(userHash ? { registrated_by_user_hash: userHash } : {})
        }} />, { 
        title: t('invoice.general.register_payment_header'),
            modalSize: 'small',
            onSuccess: () => {if (fetchData) fetchData()}
        }
    )
}